import React from 'react';
import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';
import { useAppSelector } from '~redux/hooks';
import { initialState as settingInitialState } from '~redux/slices/setting';

import { useDispatch } from 'react-redux';
import * as Styles from './_discountsSearchAndFilterStyles.module.scss';
import { TDiscountListingFilters } from '~types/feat/setting';
import { DiscountStatusEnum, TransactionActionEnum, TransactionStatusEnum } from '~utils/enums';
import combinedActions from '~redux/combinedActions';

const DiscountSearchAndFilterBar = () => {
    const dispatch = useDispatch();

    const filters = useAppSelector(state => state.setting.discounts.filters);
    const initialFilters = settingInitialState.discounts.filters;
    const nodata = false;

    const handleSearchClick = () => dispatch(combinedActions.settingGetDiscountsAttempt());

    const handleCancelClick = () => {
        dispatch(combinedActions.settingSetDiscountsListingFilters(initialFilters));
        dispatch(combinedActions.settingGetDiscountsAttempt());
    };

    const setFilters = (filter: TDiscountListingFilters) => dispatch(combinedActions.settingSetDiscountsListingFilters(filter));

    const fields: TSearchAndFilterBarProps['fields'] = [
        {
            label: 'Discount Code:',
            type: 'input' as const,
            inputParams: {
                value: filters.discountCode,
                setValue: (event) => setFilters({ ...filters, discountCode: event.target.value }),
                onKeyDown: (event) => { if (event.key === 'Enter') handleSearchClick(); },
                className: Styles.input,
            },
        },
        {
            label: 'Discount Name:',
            type: 'input' as const,
            inputParams: {
                value: filters.discountName,
                setValue: (event) => setFilters({ ...filters, discountName: event.target.value }),
                onKeyDown: (event) => { if (event.key === 'Enter') handleSearchClick(); },
                className: Styles.input,
            },
        },
        {
            label: 'Status:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: [
                    {
                        label: DiscountStatusEnum[DiscountStatusEnum.Active],
                        value: DiscountStatusEnum.Active,
                    },
                    {
                        label: DiscountStatusEnum[DiscountStatusEnum.Deactivated],
                        value: DiscountStatusEnum.Deactivated,
                    },
                ],
                value: filters.status,
                setValue: (event: React.ChangeEvent<HTMLInputElement>) => setFilters({
                    ...filters,
                    status: event.target.value,
                }),
                optionSelected: !!DiscountStatusEnum[filters.status as keyof typeof DiscountStatusEnum],
                noOptionsMessage: 'No status found',
                disabled: nodata,
            },
        },
        {
            label: 'Discount Type:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: [
                    {
                        label: TransactionActionEnum[TransactionActionEnum['Bank Sell']],
                        value: TransactionActionEnum['Bank Sell'],
                    },
                    {
                        label: TransactionActionEnum[TransactionActionEnum['Bank Buy']],
                        value: TransactionActionEnum['Bank Buy'],
                    },
                ],
                value: filters.transactionType,
                setValue: (event: React.ChangeEvent<HTMLInputElement>) => setFilters({
                    ...filters,
                    transactionType: event.target.value,
                }),
                optionSelected: !!filters.transactionType,
                noOptionsMessage: 'No branch found',
                disabled: nodata,
            },
        },
    ];
    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
        />
    );
};

export default DiscountSearchAndFilterBar;
